<template>
  <div class="flag">
    <span class="flag-icon flag-icon-br" @click="change('pt-BR')"></span>
    <span class="flag-icon flag-icon-en" @click="change('en')"></span>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    data: Object
  },
  methods: {
    change(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('zul_app_lang', lang)
      axios.defaults.headers.common['Accept-Language'] = lang
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.flag {
  padding: 8px;
}
.flag span{
  margin: 0 5px;
}
.flag-icon {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  position: relative;
  display: inline-block;
  width: 1.5em;
  line-height: 1.5em;
  cursor: pointer;
}
.flag-icon-br {
  background-image: url('../../public/img/br.svg');
}
.flag-icon-en {
  background-image: url('../../public/img/en.svg');
}
.flag-icon:before {
    content: "\00a0";
}
</style>